import { combineReducers } from "redux";
import { auth } from "./userReducer";
import { shipment } from "./shipmentReducer";
import { alerts } from "./alertMessageReducer";
import { locales } from "./localeReducer";
import { permissions } from "./permissions";
import { allorders } from "./allOrderReducer";
import { getPurchaseOrderReducer } from "./purchaseOrderReducers";
import { getBillsReducer, getVendorBillsReducer, deleteBillReducer } from './billReducers';
import { getHireMemoReducer, generateHireMemoReducer, deleteHireMemoReducer, exportHireMemoReducer } from './hireMemoReducers';
import { paginationIndex } from './paginationReducers';

export default combineReducers({
  auth,
  shipment,
  alerts,
  getBillsReducer,
  getVendorBillsReducer,
  deleteBillReducer,
  getPurchaseOrderReducer,
  getHireMemoReducer,
  generateHireMemoReducer,
  deleteHireMemoReducer,
  exportHireMemoReducer,
  locales,
  permissions,
  allorders,
  paginationIndex,
});
